import { IteratorExpression } from '../Expression.js';
import { Utils } from '../../Utils.js';
export class CollectExpression extends IteratorExpression {
    evaluate(visitor, localVariables) {
        const collection = this.getSource().evaluate(visitor, localVariables);
        if (collection instanceof Array) {
            return collection.map(c => {
                const variables = {};
                if (this.getIterators()) {
                    variables[this.getIterators()[0]] = c;
                }
                else {
                    const variableName = Utils.getVariableName(this);
                    variables[variableName.getSource().evaluate(visitor)] = c;
                }
                return this.getBody().evaluate(visitor, Object.assign(Object.assign({}, localVariables), variables));
            });
        }
        else {
            return collection;
        }
    }
}
//# sourceMappingURL=CollectExpression.js.map